<template>
<fill-in-container 
	:bizId="bizId" 
	:productCode="productCode" 
	@sub="sub" 
	:amount="amount"
	:title="`货车雇主责任险（按${type=='person'?'人':'车'}）`">
	<div slot-scope="{form}">
		<RecognizeForPerson ref="recognize" :info="form" @set-amount="val=>amount=val" :bizId="bizId" v-if="type=='person'"/>
		<RecognizeForCar ref="recognize" :info="form" @set-amount="val=>amount=val" :bizId="bizId" v-if="type=='car'"/>
	</div>
</fill-in-container>
</template>
<script>
import FillInContainer from '@/pages/haierProduct/components/common/FillInContainer'
import RecognizeForPerson from './person/Recognize'
import RecognizeForCar from './car/Recognize'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ FillInContainer,RecognizeForPerson,RecognizeForCar },
	data () {
		return {
			bizId:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE',
			amount:'',
			type:this.$route.params.type||''
		}
	},
	computed:{
		productCode(){
			return this.type=='person'?'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_PEOPLE':'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_TRUCK'
		}
	},
	methods:{
		sub(res){
			console.log(res,sessionStorage.track_session_key,'000000000000000')
			this.$router.push(`/truck-employer/confirm/${this.type}/${res}`);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/Fillin.vue